@if (hasChips) {
  <div
    class="d-flex flex-wrap"
  >
    @if (params.tab !== tabLookup.all) {
      <backstage-chip
        (remove)="setTab(tabLookup.all)">{{ params.tab.name }}
      </backstage-chip>
    }
    @for (it of params.source; track it) {
      <backstage-chip
        (remove)="removeParam('source', it)">{{ it | source }}
      </backstage-chip>
    }
    @for (it of params.entityType; track it) {
      <backstage-chip
        (remove)="removeParam('entityType', it)">{{ it | entityType }}
      </backstage-chip>
    }
    @for (it of params.publicationType; track it) {
      <backstage-chip
        (remove)="removeParam('publicationType', it)">{{ it }}
      </backstage-chip>
    }
    @for (it of params.tags; track it) {
      <backstage-chip
        (remove)="removeParam('tags', it)">{{ it }}
      </backstage-chip>
    }
    @for (it of params.library; track it) {
      <backstage-chip
        (remove)="removeParam('library', it)">Library: {{ it | libraryName }}
      </backstage-chip>
    }
    @for (it of params.status; track it) {
      <backstage-chip
        (remove)="removeParam('status', it)">{{ it }}
      </backstage-chip>
    }
    @for (it of params.priority; track it) {
      <backstage-chip
        (remove)="removeParam('priority', it)">{{ it }}
      </backstage-chip>
    }
    @for (it of params.productVersionPath; track it) {
      <backstage-chip
        (remove)="removeProductVersionPathParams(it)">{{ it | productVersionPath }}
      </backstage-chip>
    }
  </div>
}
